import { Navigate } from 'react-router-dom';
import AdminPanel from '@/components/AdminPanel';
import NavBar from '@/components/NavBar';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';

const Admin = () => {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-bg flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (userRole !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-bg">
      <NavBar />
      <div className="container mx-auto px-6 py-8">
        <AdminPanel />
      </div>
    </div>
  );
};

export default Admin;